module.exports = {
  background: '#FFFFFF',
  backgroundDark: '#f0e6f6',

  primary: '#7c37ad',
  primaryLight: '#ae66df',
  primaryDark: '#4b007d',

  secondary: '#00A896',
  secondaryLight: '#02C39A',
  secondaryDark: '#028090',
};
